import React from "react";
import { useHistory } from "react-router-dom";
import ContainerAuthenticated from "containers/Authenticated";

import {
    PageWrapper,
    BackButton,
    PageHeader,
    PageTitle,
    PageSubtitle,
    CharactersGrid,
    CharacterCard,
    CharacterImage,
    CharacterName,
    CharacterRole,
    CharacterCTA
} from "screens/Dashboard/Learning/styled";

// Lista de personagens do Modo Bate-papo (ChatBox05-08)
const characters = [
    {
        name: 'Salomão',
        role: 'Rei sábio',
        image: '/images/salomao_pixel.png',
        path: '/dashboard/chatbox05'
    },
    {
        name: 'Daniel',
        role: 'Profeta visionário',
        image: '/images/daniel_pixel.png',
        path: '/dashboard/chatbox06'
    },
    {
        name: 'Ester',
        role: 'Rainha corajosa',
        image: '/images/ester_pixel.png',
        path: '/dashboard/chatbox07'
    },
    {
        name: 'Davi',
        role: 'Rei guerreiro',
        image: '/images/davi_pixel.png',
        path: '/dashboard/chatbox08'
    }
];

export default function DashboardConversation() {
    const history = useHistory();

    const goToCharacter = (path) => history.push(path);
    const goBack = () => history.push('/dashboard');

    return (
        <ContainerAuthenticated primary page={'conversation'}>
            <PageWrapper>
                <BackButton onClick={goBack} aria-label="Voltar para escolha de modo">
                    ← Voltar
                </BackButton>

                <PageHeader>
                    <PageTitle>💬 Modo Bate-papo</PageTitle>
                    <PageSubtitle>
                        Escolha um personagem e comece a conversar. Pergunte, peça sugestões, explore ideias — sem julgamentos.
                    </PageSubtitle>
                </PageHeader>

                <CharactersGrid>
                    {characters.map((char) => (
                        <CharacterCard key={char.name} onClick={() => goToCharacter(char.path)}>
                            <CharacterImage
                                src={char.image}
                                alt={`${char.name} — ${char.role}`}
                                width="180"
                                height="180"
                            />
                            <CharacterName>{char.name}</CharacterName>
                            <CharacterRole>{char.role}</CharacterRole>
                            <CharacterCTA>Conversar com {char.name.split(' ')[0]} →</CharacterCTA>
                        </CharacterCard>
                    ))}
                </CharactersGrid>
            </PageWrapper>
        </ContainerAuthenticated>
    );
}
